import { marketingFontLinks } from '../lib/marketingFonts';

import { type LinksFunction, type MetaFunction } from 'react-router';

export const links: LinksFunction = marketingFontLinks;

import ForNewslettersPage from '../../src/pages/for-newsletters/ForNewslettersPage';
import MarketingLayout from '../../src/components/SharedLayout/MarketingLayout';
import { getCanonicalUrl } from '../../src/lib/utils/url';
import { preloadHomepageSections } from '../../src/pages/for-newsletters/homepageSections';

// Prerender includes every section. Hydration can attach the core controls while
// later section code arrives; client navigations retain the current complete page.
export function loader() {
  return null;
}

export async function clientLoader() {
  await preloadHomepageSections();
  return null;
}

export const meta: MetaFunction = () => {
  const canonical = getCanonicalUrl('/');
  const title = 'Atrivial for Newsletters | Interactive Trivia for Publishers';
  const description =
    'Turn newsletter content into Quizzes with Newsletter HTML and hosted Quiz links. Individual, Business, and Enterprise plans with a 14-day free trial.';
  const ogImage = getCanonicalUrl('/og-newsletters-v1.png');
  const imageAlt = 'Atrivial. Give readers another reason to open. An example newsletter quiz.';
  return [
    { title },
    { name: 'description', content: description },
    { tagName: 'link', rel: 'canonical', href: canonical },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:url', content: canonical },
    { property: 'og:image', content: ogImage },
    { property: 'og:image:type', content: 'image/png' },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '630' },
    { property: 'og:image:alt', content: imageAlt },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: ogImage },
    { name: 'twitter:image:alt', content: imageAlt },
  ];
};

export default function Index() {
  return (
    <MarketingLayout>
      <ForNewslettersPage />
    </MarketingLayout>
  );
}
